import React from "react";
import tickImg from "../../images/icons/green-tick.png";
import failImg from "../../images/icons/failure.png";
import {useDispatch} from "react-redux";
import {setShowKeyboard} from "../../actions/global";
import "./style.scss";

function TextInput({
  name,
  label,
  type,
  placeholder,
  value,
  alert,
  setInputs,
  defaultInput,
  maxlengthValue,
  labelName,
  disableItem,
  isSuccess,
  isWelcomePage,
}) {
  const dispatch = useDispatch();
  return (
    <div>
      <label htmlFor={name} className="custom-label">
        {label} {labelName}
      </label>
      <div
        className="custom-field-default-div"
        onClick={() => {
          dispatch(setShowKeyboard(true));
        }}
      >
        {defaultInput ? (
          <div className="custom-field-default-text">{defaultInput}</div>
        ) : (
          ""
        )}
        <input
          id={name}
          name={name}
          type={type}
          placeholder={`${placeholder ? placeholder : ""} ${
            labelName ? labelName : ""
          }`}
          value={value || ""}
          onChange={setInputs}
          maxLength={maxlengthValue || 200}
          disabled={disableItem || false}
          className={`${
            disableItem ? "disbaled-custom-input" : "custom-input"
          } ${alert && value?.length > 0 ? "input-error" : ""}`}
          readOnly={name == "common-text" ? "readOnly" : ""}
        />
        {value?.length ? (
          isSuccess ? (
            <img
              className="guestPage-tick-icon"
              src={tickImg}
              alt="tick_icon"
            />
          ) : !isWelcomePage ? (
            <img
              className="guestPage-tick-icon"
              src={failImg}
              alt="tick_icon"
            />
          ) : null
        ) : null}
      </div>
      {value?.length ? (
        <span className="input-error-label">{alert}</span>
      ) : null}
    </div>
  );
}

export default TextInput;
